import { PointScaleRatingType, QuestionTypeVariantType } from 'shared/types';

export const MAX_ALL_LABEL_LIMIT = 7;

export const SCORE_SIZE = 44;
export const GAP = 8;

export const TYPE_VARIANT_CHOICES_PNG: Record<
  Extract<QuestionTypeVariantType, 'THUMBS' | 'TICK' | 'EMOJI' | 'TEXT'>,
  [string, string]
> = {
  THUMBS: ['thumbs-down', 'thumbs-up'],
  TICK: ['no', 'yes'],
  EMOJI: ['smile-1', 'smile-10'],
  TEXT: ['', ''],
};

export const EMOJI_PICK_HELPER: Record<PointScaleRatingType, number[]> = {
  '10': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  '9': [1, 2, 3, 4, 5, 6, 7, 9, 10],
  '8': [2, 3, 4, 5, 6, 7, 9, 10],
  '7': [2, 3, 4, 5, 6, 9, 10],
  '6': [2, 3, 4, 6, 9, 10],
  '5': [2, 4, 5, 6, 10],
  '4': [3, 4, 6, 7],
  '3': [3, 5, 7],
};

export const TYPE_VARIANT_CHOICES_GLYPH: Record<
  Extract<QuestionTypeVariantType, 'THUMBS' | 'TICK' | 'EMOJI' | 'TEXT'>,
  [string, string]
> = {
  THUMBS: ['thumbs-down', 'thumbs-up'],
  TICK: ['tick-no', 'tick-yes'],
  EMOJI: ['emoji-negative', 'emoji-positive'],
  TEXT: ['', ''],
};
